import React from "react";
import { observer } from "mobx-react";
import { SignedEditionDndaWorkflowStateCreateStore } from "../../store";
import { SignedEditionDndaWorkflowStateCreateForm } from "./SignedEditionDndaWorkflowStateCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type SignedEditionDndaWorkflowStateCreateProps = {
  signedEditionDndaWorkflowStateCreateStore: SignedEditionDndaWorkflowStateCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const SignedEditionDndaWorkflowStateCreate: React.FC<SignedEditionDndaWorkflowStateCreateProps> =
  observer(
    ({
      signedEditionDndaWorkflowStateCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay
            open={signedEditionDndaWorkflowStateCreateStore.isSaving}
          />
          <SignedEditionDndaWorkflowStateCreateForm
            signedEditionDndaWorkflowStateCreateStore={
              signedEditionDndaWorkflowStateCreateStore
            }
            name_esError={
              signedEditionDndaWorkflowStateCreateStore.errors.name_es?.message
            }
            onName_esChange={(value: string) => {
              signedEditionDndaWorkflowStateCreateStore.setName_esValue(value);
            }}
            name_es={
              signedEditionDndaWorkflowStateCreateStore.entityValues.name_es
            }
            name_enError={
              signedEditionDndaWorkflowStateCreateStore.errors.name_en?.message
            }
            onName_enChange={(value: string) => {
              signedEditionDndaWorkflowStateCreateStore.setName_enValue(value);
            }}
            name_en={
              signedEditionDndaWorkflowStateCreateStore.entityValues.name_en
            }
            name_ptError={
              signedEditionDndaWorkflowStateCreateStore.errors.name_pt?.message
            }
            onName_ptChange={(value: string) => {
              signedEditionDndaWorkflowStateCreateStore.setName_ptValue(value);
            }}
            name_pt={
              signedEditionDndaWorkflowStateCreateStore.entityValues.name_pt
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={signedEditionDndaWorkflowStateCreateStore.isProcessing}
            onSave={() =>
              signedEditionDndaWorkflowStateCreateStore.saveNewSignedEditionDndaWorkflowState()
            }
            onCancel={() =>
              signedEditionDndaWorkflowStateCreateStore.cancelNewSignedEditionDndaWorkflowState()
            }
          />
          <ErrorDialog
            open={signedEditionDndaWorkflowStateCreateStore.errorDialogOpened}
            title={signedEditionDndaWorkflowStateCreateStore.errorTitle}
            description={
              signedEditionDndaWorkflowStateCreateStore.errorDescription
            }
            onClose={() =>
              signedEditionDndaWorkflowStateCreateStore.closeErrorDialog()
            }
          />
        </>
      );
    }
  );
